import { render, staticRenderFns } from "./InviteExpired.vue?vue&type=template&id=a63baa7a&"
import script from "./InviteExpired.vue?vue&type=script&lang=js&"
export * from "./InviteExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports